var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EmailComp",
    clipPath: "url(#clip0_839_4361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 5.6875C32 3.7625 30.56 2.1875 28.8 2.1875H3.2C1.44 2.1875 0 3.7625 0 5.6875V26.6875C0 28.6125 1.44 30.1875 3.2 30.1875H28.8C30.56 30.1875 32 28.6125 32 26.6875V5.6875ZM28.8 5.6875L16 14.4375L3.2 5.6875H28.8ZM28.8 26.6875H3.2V9.1875L16 17.9375L28.8 9.1875V26.6875Z",
    fill: "#FFFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_4361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.1875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2dbabeb99dab9bbb5a056d6d252eac2f.svg";
export { ForwardRef as ReactComponent };